import { render, staticRenderFns } from "./article.vue?vue&type=template&id=74fa09e0&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fa09e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74fa09e0')) {
      api.createRecord('74fa09e0', component.options)
    } else {
      api.reload('74fa09e0', component.options)
    }
    module.hot.accept("./article.vue?vue&type=template&id=74fa09e0&scoped=true", function () {
      api.rerender('74fa09e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/article.vue"
export default component.exports